import { CommonModule, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { SelectableWidget } from '@components/selectable-widget/selectable-widget.component';
import { CurrencyAmountComponent } from '@cxc/ui-kit/components/currency-amount';

import { CURRENCY } from '@cxc/core/enums';

import { OverviewResumeState } from '@services/state/overview-resume-state/overview-resume.state';

@Component({
  selector: 'core-metrics',
  standalone: true,
  imports: [
    CommonModule,
    UpperCasePipe,
    SelectableWidget,
    CurrencyAmountComponent,
  ],
  templateUrl: './core-metrics.component.html',
  styleUrl: './core-metrics.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreMetrics {
  public indicators = inject(OverviewResumeState).coreMetrics;

  exportMode = input<boolean>(false);
  selectedWidgets = input<HTMLElement[]>([]);
  // Overview's stored figures are MXN (LEN-1808) unless the user picked a
  // different display currency via the selector.
  currency = input<CURRENCY>(CURRENCY.MXN);
  widgetToggle = output<{ checked: boolean; el: HTMLElement }>();

  isWidgetSelected(el: HTMLElement): boolean {
    return this.selectedWidgets().includes(el);
  }
}
